import { render } from "./BookModel.vue?vue&type=template&id=07351c66&scoped=true"
import script from "./BookModel.vue?vue&type=script&lang=js"
export * from "./BookModel.vue?vue&type=script&lang=js"

import "./BookModel.vue?vue&type=style&index=0&id=07351c66&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07351c66"]])

export default __exports__